<template>
  <div
    :class="['form-group', 'ob1-promotional-code', { 'form-group-inverse': darkMode }]"
    data-ob1-component="PromotionalCode">
    <promotional-code-info
      v-if="infoMessage"
      :message="infoMessage" />

    <promotional-code-content
      ref="promotionalCodeInput"
      :label="inputLabel"
      :helper-text="inputHelperText"
      :is-invalid="errorMessage !== null"
      @input-focus="onInputFocus"
      @input-blur-and-empty="onInputBlurAndEmpty"
      @input-update="onInputUpdate">
      <promotional-code-error
        v-if="errorMessage"
        :message="errorMessage" />
    </promotional-code-content>

    <promotional-code-button-add
      v-if="showAddButton && !showSpinner"
      :disabled="disableAddButton"
      :dark-mode="darkMode"
      :label="addButtonLabel"
      :action-cb="onAdd" />

    <!-- Spinner for waiting states -->
    <promotional-code-spinner v-else-if="showSpinner && errorMessage === null" />
  </div>
</template>

<script>
import PromotionalCodeButtonAdd from './promotionalCodeButtonAdd/PromotionalCodeButtonAdd'
import PromotionalCodeContent from './promotionalCodeContent/PromotionalCodeContent'
import PromotionalCodeError from './promotionalCodeError/PromotionalCodeError'
import PromotionalCodeInfo from './promotionalCodeInfo/PromotionalCodeInfo'
import PromotionalCodeSpinner from './promotionalCodeSpinner/PromotionalCodeSpinner'

export default {
  name: 'PromotionalCodeForm',
  components: {
    PromotionalCodeButtonAdd,
    PromotionalCodeContent,
    PromotionalCodeError,
    PromotionalCodeInfo,
    PromotionalCodeSpinner
  },
  props: {
    inputLabel: {
      type: String,
      required: true
    },
    addButtonLabel: {
      type: String,
      required: true
    },
    inputHelperText: {
      type: String,
      default: null
    },
    infoMessage: {
      type: String,
      default: null
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showAddButton: false,
      showSpinner: false
    }
  },
  computed: {
    inputValue () {
      return this.$refs.promotionalCodeInput ? this.$refs.promotionalCodeInput.input : ''
    },
    disableAddButton () {
      return this.inputValue === ''
    }
  },
  methods: {
    onInputFocus () {
      this.showAddButton = true
    },
    onInputBlurAndEmpty () {
      this.showAddButton = false
    },
    onAdd () {
      this.showSpinner = true
      this.$emit('add', this.inputValue)
    },
    onInputUpdate () {
      this.showSpinner = false
      this.$emit('clear-error')
    }
  }
}
</script>
